<template>
  <div id="app">
    <router-view />
    <GlobalModal />
    <DMReportNotification />
    <DMCopyNotification />
    <DMRiseBulkNotification />
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import DMReportNotification from './components/DMReportNotification'
import DMCopyNotification from './components/DMCopyNotification'
import DMRiseBulkNotification from './components/DMRiseBulkNotification'
import GlobalModal from '@/components/GlobalModal'

export default {
  name: 'App',
  components: {
    DMReportNotification,
    DMCopyNotification,
    DMRiseBulkNotification,
    GlobalModal
  },

  computed: {
    ...mapState('user', ['token', 'userEcosystems']),
    ...mapGetters({
      identityReference: 'chat/identityReference',
    })
  },
  watch: {
    identityReference: {
      immediate: true,
      handler() {
        this.$store.dispatch('chat/applyStrategy')
      }
    }
  },
  created() {
    if (this.token) {
      this.getScreens()
      this.getModules()
    }
  },

  methods: {
    ...mapActions('screens', ['getScreens']),
    ...mapActions('modules', ['getModules'])
  }
}
</script>
